import { styled } from '@mui/material/styles';
import { Box, Typography, TextField, Autocomplete, Button } from '@mui/material';

export const TitleTypography = styled(Typography)({
  fontSize: "1.75rem",
  fontWeight: "bold"
});

export const SubtitleTypography = styled(Typography)<{ theme: any }>(({ theme }) => ({
  fontSize: "1.25rem",
  color: theme.palette.text.secondary
}));

export const SpacedTypography = styled(Typography)({
  marginTop: "42px"
});

export const ImageUploadBox = styled(Box)<{ theme: any }>(({ theme }) => ({
  height: "135px",
  width: "240px",
  borderRadius: "12px",
  backgroundColor: theme.palette.background.default,
  cursor: "pointer"
}));

export const ImagePreview = styled('img')({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "12px",
  border: "1px solid gray"
});

export const ImagePlaceholderBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%"
});

export const ErrorTypography = styled(Typography)({
  fontSize: "0.75rem"
});

export const FieldTypography = styled(Typography)({
  marginTop: "26px"
});

export const StyledTextField = styled(TextField)({
  marginTop: "16px",
  width: "100%",
  '& fieldset': {
    borderRadius: '19px'
  }
});

export const StyledAutocomplete = styled(Autocomplete<string, false, true, true>)({
  marginTop: "16px",
  '& fieldset': {
    borderRadius: '19px'
  }
});

export const DescriptionTextField = styled(TextField)({
  marginTop: "16px",
  marginBottom: "16px",
  width: "100%",
  '& fieldset': {
    borderRadius: '23px'
  }
});

export const ToggleDrawerButton = styled(Button)<{ drawerOpen?: boolean }>(({ drawerOpen }) => ({
  left: drawerOpen ? `${window.innerWidth * 0.28 + 80}px` : '80px'
})); 